module.exports = __webpack_public_path__ + "static/media/warning-white.049a2fd1.svg";